const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');

/**
 * Defines the dynamic messaging component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('dynamicMessageManager', ['Application', 'DynamicMessages', function (Application, DynamicMessages) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      content: '=',
      contentId: '=',
      contentType: '@',
      noIdMessage: '=',
      isMultiSession: '='
    },
    template: require('../../../templates/directives/messaging/dynamic-message-manager.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.showSearch = false;


      self.userSearch = {
        show: false,
        list: [],
        select: function(item) {
          self.userSearch.list = [];
          if (!item || !item.user_deliveries || !item.user_deliveries.length) {
            return;
          }
          self.userSearch.list = item.user_deliveries.map(function(user) {
            return user.user;
          });

          self.userSearch.show = true;
        }
      };

      self.capWords = function(str){
        return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
      };

      self.messages = {
        activeItem: null,
        displayDynamic: false,
        triggerMap: {
          before_start: ' before',
          after_end: ' after',
          on_register: 'On registration',
          on_register_msw: 'On registration'
        },
        itemMap: {
          in_app: 'In app',
          email: 'Email',
          slack: 'Slack'
        },
        deliveryCounts: {},
        getMessages: function() {
          if (!$scope.content || (!$scope.contentId)) {
            return;
          }

          return DynamicMessages.find({'content_id': $scope.contentId, fields: 'name,type,channels,messages,user,scheduled_duration,content_id,options,user_deliveries', 'user-populate': 'first_name,last_name,email,role'}).$promise
          .then(function(messages) {
            self.messages.list = messages;
            return messages;
          }).catch(function(error) {
            console.log('error: ', error);
          });
        },
        formatSchedule: function(notif) {
          if (!notif.type || !self.messages.triggerMap[notif.type]) {
            return '--';
          }
          if (!notif.scheduled_duration) {
            return self.messages.triggerMap[notif.type];
          }

          var humanize = notif.scheduled_duration ? moment.duration(notif.scheduled_duration, 'seconds').humanize() : '';
          humanize = humanize === 'an hour' ? '1 Hour' : humanize === 'a day' ? '1 Day' : humanize;
          return  self.messages.triggerMap[notif.type] === 'On registration' ? 'On registration' : humanize + self.messages.triggerMap[notif.type];
        },
        getTypes: function(item) {
          var list = '';
          item.channels.forEach(function(channel) {
            if (!self.messages.itemMap[channel]) {
              return;
            }
            list += self.messages.itemMap[channel] + ' | ';
          });
          if (list && list.match(/(\| In app )/gi)){
            return (list.replace(/(\| In app )/gi, '').slice(0, -3) + ' | In-App') ;
          } else if (list) {        
            return list ? list.slice(0, -3): '';
          };
        },
        getAudience: function(item) {
          if (!item.options || !item.options.length) {
            return '--';
          }
          var list = '';
          item.options.forEach(function(option) {
            if (option.name === 'audience' && option.value) {
              list += option.value + ' | ';
            }
          });
          return list ? list.slice(0, -3) : '';
        },
        onSuccess: function(text) {
          self.messages.getMessages()
          .then(function() {
            Application.messaging.addMessage({type: 'success', duration: 5, text: text});
            self.messages.displayDynamic = false;
            self.messages.activeItem = null;
          });
        },
        remove: function(item) {
          // find _id and remove from both comms and delete record
          DynamicMessages.remove({subresource: item._id}).$promise
          .then(self.messages.getMessages)
          .then(function() {
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Message successfully removed'});
            self.messages.displayDynamic = false;
          })
        },
        edit: function(item) {
          // Pass item _id into templating component
          self.messages.activeItem = item._id;
          self.messages.displayDynamic = true;
        },
        addNew: function() {
          if (!$scope.content || (!$scope.contentId)) {
            var message = $scope.noIdMessage || 'Please create this content before adding notifications.';
            Application.messaging.addMessage({text: message, type: 'error', duration: 7});
            return;
          }
          self.messages.activeItem = null;
          self.messages.displayDynamic = true;
        }
      };

      if ($scope.content && ($scope.contentId)) {
        self.messages.getMessages();
        return;
      }

      var idWatch = $scope.$watch('content', function(newVal, oldVal) {
        if (newVal._id) {
          self.messages.getMessages();
          idWatch();
        }
      }, true);

    }],
    controllerAs: 'manager'
  };
}]);